import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Inbox, Plus, LayoutDashboard, Users, Tag } from 'lucide-react';
import { UsuarioContext } from '../../providers/personaContext';
import CustomTooltip from '../../elementos/eventos/avisos/Tooltip';

/**
 * Sub-sidebar del módulo Soporte para la franja gris global de Sidebar.js.
 * Mis tickets / Nuevo: visibles a todos. Panel / Equipo: soporte.panel.view.
 * Áreas: soporte.panel.manage. (Mismo patrón visual que FormacionSidebar.)
 */
function headerStyle(color) {
  return {
    padding: '14px 12px 4px', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase',
    letterSpacing: '0.06em', color, listStyle: 'none', pointerEvents: 'none', userSelect: 'none',
  };
}

function MenuItem({ to, end, Icon, label, showSidebar }) {
  return (
    <li>
      <NavLink activeclassname="active" end={end} to={to}>
        <div className={`menuBtn ${showSidebar ? 'expanded' : 'collapsed'}`}>
          {showSidebar ? (
            <>
              <Icon />
              <span className="menuText">{label}</span>
            </>
          ) : (
            <CustomTooltip mensaje={label} alineado="left" tamano="1.0rem">
              <div>
                <Icon />
              </div>
            </CustomTooltip>
          )}
        </div>
      </NavLink>
    </li>
  );
}

export default function SoporteSidebar({ showSidebar = true }) {
  const ctx = useContext(UsuarioContext) || {};
  const isSuperAdmin = (ctx.persona?.rol || '').toLowerCase() === 'super administrador';
  const permisos = Array.isArray(ctx.permisos) ? ctx.permisos : [];
  const can = (clave) => isSuperAdmin || permisos.includes(clave);
  const permisosCargados = isSuperAdmin || ctx.permisosCargados;

  // Mis tickets / Nuevo: siempre. El resto, solo cuando los permisos ya cargaron.
  const verPanel = permisosCargados && can('soporte.panel.view');
  const verAreas = permisosCargados && can('soporte.panel.manage');

  return (
    <>
      <MenuItem to="/soporte/mis-tickets" Icon={Inbox} label="Mis tickets" showSidebar={showSidebar} />
      <MenuItem to="/soporte/nuevo" Icon={Plus} label="Nuevo ticket" showSidebar={showSidebar} />

      {verPanel && (
        <>
          {showSidebar && <li style={headerStyle('#64748b')}>Administración</li>}
          <MenuItem to="/soporte/panel" end Icon={LayoutDashboard} label="Panel" showSidebar={showSidebar} />
          <MenuItem to="/soporte/equipo" Icon={Users} label="Equipo" showSidebar={showSidebar} />
        </>
      )}

      {verAreas && (
        <>
          {showSidebar && <li style={headerStyle('#64748b')}>Configuración</li>}
          <MenuItem to="/soporte/configuracion/areas" Icon={Tag} label="Áreas" showSidebar={showSidebar} />
        </>
      )}
    </>
  );
}
